<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2021-01-20 11:32:25
 * @LastEditors: daikeyi
 -->
<template>
    <div id='page_Container'>
        <div class="page">
            <!-- <h1 :class="{exchangeText: !isOkShow}"></h1> -->
            <!-- <h1 class="exchangeText" @click="jumpTo('OPExchangeCoupon')">兑换</h1> -->
            <div id='main-container' class="main-container">
                <van-tabs v-model="active" swipeable @change="tabChange">
                    <van-tab :title="item.value" v-for="item in tabArr" :key="item.key">
                        <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :class="noData">
                            <van-list v-model="ploading" :finished="finished"  @load="onLoad" :offset="1" class="coupon-list">
                                <div class='couponListBox' v-if='listShow'>
                                    <div class='couponList' v-for='item in canDoCouponList' :key='item.id'>
                                        <div class='couponListTop'>
                                            <van-row>
                                                <van-col span="16" class='vanColOne'>
                                                    <strong>{{item.couponSimpleName ? item.couponSimpleName : item.couponName ? item.couponName : '--'}}</strong>
                                                </van-col>
                                                <van-col span="8" class='vanColTwo' v-if="String(item.type) === '5'">

                                                    <strong>{{item.faceAmount || 0}}</strong>
                                                    折
                                                </van-col>
                                                <van-col span="8" class='vanColTwo' v-else>¥
                                                    <strong>{{item.faceAmount || 0}}</strong>
                                                </van-col>
                                            </van-row>
                                            <van-row>
                                                <van-col span="16" class='colOne'>
                                                    有效期{{item.couponValidityStart + '~' + item.couponValidityEnd}}
                                                </van-col>
                                                <van-col span="8" class='colTwo'>
                                                    满{{item.thresholdAmount || 0}}元可用
                                                </van-col>
                                            </van-row>
                                        </div>
                                        <van-row>
                                            <van-col span="24" class='couponBottom'>
                                                {{item.remark ? item.remark : '暂无说明'}}
                                            </van-col>
                                        </van-row>
                                    </div>
                                </div>
                                <!-- 无券 -->
                                <div class='text' v-if='finished'>
                                    <img v-if='!listShow' :src="noListUrl" alt="">
                                    <p>没有更多有效劵了 |
                                        <span @click='seeVoucher'>查看无效劵>></span>
                                    </p>
                                </div>
                            </van-list>
                        </van-pull-refresh>
                    </van-tab>
                </van-tabs>
            </div>
        </div>
    </div>
</template>
<script>
import { toastLoading, clearToastLoading } from '@/utils/base/utils';
export default {
    data() {
        return {
            active: 4,
            tabArr: [{ key: 4, value: '优惠券' }, { key: 3, value: '活动券' }],
            states: '10,11',
            listParams: {
                pageNum: 1,
                pageSize: 5,
                states: '10,11',
                type: 4
            },
            noListUrl: require('../assets/img/myCenter/noList.png'),
            loading: false,
            isLoading: false,
            ploading: false,
            finished: true,
            finishedOk: false,
            show: false,
            qSwitch: false,
            value: '',
            valueK: '',
            leftUrl: require('../assets/img/myCenter/leftclick.png'),
            canDoCouponList: [],
            failCouponList: [],
            isOkShow: false
        };
    },
    esvShow() {
        const ths = this;
        this.queryCouponSuccessList(1);
        window.addEventListener(
            'popstate',
            function(e) {
                if (ths.vouchershow) {
                    ths.vouchershow = false;
                    ths.$router.go(-1);
                } else {
                }
            },
            false
        );
    },
    esvReady() {},
    methods: {
        tabChange(name, type) {
            console.log(name, type, this.tabArr[name].key);
            this.listParams = { ...this.listParams, states: this.states, type: this.tabArr[name].key, pageNum: 1 };
            this.queryCouponSuccessList();
        },
        // 下拉刷新
        onLoad() {
            this.listParams.pageNum++;
            this.queryCouponSuccessList();
        },
        onRefresh() {
            this.listParams.pageNum = 1;
            this.queryCouponSuccessList();
        },
        // 请求卡券列表
        queryCouponSuccessList() {
            const ths = this;
            ths.$doRequest(
                {
                    url: '/coupon/queryCouponList',
                    params: { ...this.listParams },
                    // complete: function() {
                    //     ths.isLoading = false;
                    // },
                    before: function() {
                        // ths.loading = toastLoading();
                    },
                    complete: () => {
                        // clearToastLoading(ths.loading);
                        // ths.isLoading = false;
                        this.ploading = false;
                        this.isLoading = false;
                    }
                },
                (data) => {
                    // this.canDoCouponList = [];
                    if (this.listParams.pageNum === 1) {
                        this.canDoCouponList = [];
                    }
                    this.canDoCouponList.push(...data.result.list);
                    if (data.result.endRow >= data.result.total) {
                        this.finished = true;
                    } else {
                        this.finished = false;
                    }
                },
                (data) => {
                    this.$toast('加载失败');
                    this.canDoCouponList = [];
                }
            );
        },
        // 请求卡券列表
        queryCouponFailList(states) {
            const ths = this;
            ths.$doRequest(
                {
                    url: '/coupon/queryCouponList',
                    params: {
                        states: states,
                        pageSize: 10000

                    },
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                        ths.isLoading = false;
                    }
                },
                function(data) {
                    // 是否显示字体
                    ths.isOkShow = true;
                    ths.ESVStorage.putSavedValue(
                        'failCouponList',
                        data.result.list
                    );
                    ths.esvOpenPage({
                        name: 'OPSeeVoucher'
                    });
                }
            );
        },
        // 点击确定卡券
        conversionCoupon() {
            const ths = this;
            ths.qSwitch = false;
            ths.$doRequest(
                {
                    url: '/mobile/coupon/conversionCoupon',
                    params: {
                        code: ths.value

                    },
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    ths.queryCouponList();
                    ths.value = '';
                    ths.qSwitch = true;
                    ths.value = '';
                }
            );
        },
        onClickRight() {
            this.show = true;
        },
        seeVoucher() {
            this.queryCouponFailList(3);
        },
        jumpTo(name) {
            const self = this;
            self.esvOpenPage({
                name
            });
        },
        beforeClose(action, done) {
            if (action === 'confirm') {
                this.conversionCoupon();
                if (this.qSwitch) {
                    setTimeout(() => {
                        this.$toast('领券成功');
                        done();
                    }, 1000);
                } else {
                    setTimeout(() => {
                        done(function() {});
                    }, 700);
                }
            } else {
                done();
            }
        }
    },
    computed: {
        listShow() {
            return this.canDoCouponList.length > 0;
        },
        noData() {
            return { 'no-data': !this.listShow };
        }
    }
};
</script>
<style lang="scss" scoped>
.h100 {
    height: 100%;
}
.no-data {
    height: 100%;
    /deep/ .van-pull-refresh__track {
        height: 100%;
        .coupon-list {
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
    // display: flex;
    // height: 100%;
}
.exchangeText {
    font-weight: normal;
    font-size: 16px;
    float: right;
    cursor: pointer;
    padding: 1px;
    margin: 10px;
}
.couponListBox {
    .couponList:nth-child(1) {
        margin-top: 0;
    }
    .couponList {
        background: url(../assets/img/myCenter/couponBg.png) no-repeat center
            center;
        min-height: 118px;
        background-size: cover;
        padding: 12px;
        margin-top: 12px;
        .couponListTop {
            border-bottom: 1px dotted #f1f1f1;
            padding-bottom: 8px;
            p {
                overflow: hidden;
                span {
                    font-size: 14px;
                }
                .name {
                    float: left;
                }
                .money {
                    color: red;
                    float: right;
                }
                .time {
                    float: left;
                    color: #999;
                }
                .je {
                    float: right;
                    color: #999;
                }
            }
        }
        .couponBottom {
            color: #999;
            text-align: left;
            margin-top:5px;
            p {
                padding: 5px 0;
                color: #999;
            }
        }
    }
}
.text {
    color: #666666;
    font-size: 14px;
    text-align: center;
    img{
        width:203px;
    }
    p {
        margin: 20px 0;
        color: #666666;
        font-size: 14px;
        text-align: center;
        span{
            text-decoration:underline;
        }
    }
}
.couponRight {
    width: 100%;
    height: 100%;
    background: #f2f2f2;
    overflow: auto;
}
.dialogStyle {
    text-align: center;
    h5 {
        padding: 10px 0;
    }
}
.couponBottomgq {
    background: url(../assets/img/myCenter/gq.png) no-repeat right 0px;
    background-size: 34px;
    height: 30px;
}
.voucherStyle {
    margin-top: 0;
    color: #999;
    .money {
        color: #999 !important;
    }
}
.btnStyle {
    text-align: center;
    .van-button {
        width: 80%;
    }
}
.vanColOne {
    text-align: left;
    strong {
        font-size: 14px;
    }
}
.vanColTwo {
    text-align: right;
    color: red;
    strong {
        font-size: 18px;
    }
}
.colOne {
    color: #999;
    text-align: left;
}
.colTwo {
    text-align: right;
}
</style>
